import { ONLINE_USERS, GET_SOCKET } from "./socketActions";

// initial state values
const initialState = {
  socket: null,
  onlineUsers: [],
};

// Then we need to have the reducer
const socketReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SOCKET:
      return {
        ...state,
        socket: payload,
        onlineUsers: [],
      };

    case ONLINE_USERS:
      return {
        ...state,
        onlineUsers: payload,
      };

    default:
      return state;
  }
};

export default socketReducer;
